<div class="modal-header">
    <h4 class="modal-title">{{ title() | translate }}</h4>
</div>
<div class="modal-body">
    <ng-content></ng-content>
</div>
